import BillingDistribution from "./BillingDistribution.vue";
import DistributionDetail from "./DistributionDetail.vue";
import { useDistributionStore } from "./store/useDistributionStore";
import { usePaymentStore } from "./store/usePaymentStore";
import { useUpdateDistributionStore } from "./store/useUpdateDistributionStore";
import { useDistributionNavigationStore } from "./store/useDistributionNavigationStore";
export default {
  name: "DistributionMain",
  props: {
    alerts: {
      type: Object,
      required: true
    },
    modalService: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  components: {
    BillingDistribution,
    DistributionDetail
  },
  setup(props) {
    const paymentStore = usePaymentStore();
    const distributionStore = useDistributionStore();
    const updateDistributionStore = useUpdateDistributionStore();
    const distributionNavigationStore = useDistributionNavigationStore();
    paymentStore.alerts = props.alerts;
    distributionStore.alerts = props.alerts;
    updateDistributionStore.alerts = props.alerts;
    distributionStore.reloadDistributionParms();
    function sectionToggle(value) {
      distributionNavigationStore.sectionToggle(value);
    }
    const {
      section
    } = distributionNavigationStore;
    return {
      section,
      sectionToggle
    };
  }
};